import { request } from '@/utils/request';
import ENDPOINT from "@/config/endpoint";

function getBucketList(params = null) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets`,
    method: 'get',
    params: params,
  });
}

function createBucket(data) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets`,
    method: 'post',
    data,
  });
}

function deleteBucket(bucketName) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}`,
    method: 'delete',
  });
}

function getBucket(bucketName, params = null) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}`,
    method: 'get',
    params: params,
  });
}

function getS3UserInfo() {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/me`,
    method: 'get',
  });
}

function createS3UserInfo() {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/me`,
    method: 'post',
  });
}

function getBucketDetail(bucketName) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}`,
    method: 'get',
  });
}

function createKey(payload) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/keys`,
    method: 'post',
    data: payload,
  });
}

function deleteKey(data) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/keys`,
    method: 'delete',
    data,
  });
}

function getFiles(bucketName) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/files`,
    method: 'get',
  });
}

function getFilesNoPrefix(bucketName) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/objects/list`,
    method: 'get',
  });
}

function getFilesPrefix(bucketName, prefix, params) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/objects/list/${prefix}`,
    method: 'get',
    params,
  });
}

function deleteFile(bucketName, filePath) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/files/${filePath}`,
    method: 'delete',
  });
}

function deleteFileVersion(bucketName, filePath, versionId) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/files/${filePath}?version_id=${versionId}`,
    method: 'delete',
  });
}

function uploadS3File(bucketName, filePath, data) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/files/${filePath}`,
    method: 'post',
    data,
  });
}

function actionS3(bucketName, filePath, data) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/files/${filePath}`,
    method: 'patch',
    data,
  });
}

function downloadS3File(bucketName, filePath, params = {}) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE2}/${bucketName}/${filePath}`,
    method: 'get',
    responseType: 'blob',
    params,
  });
}

function getAccessControl(bucketName) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/acl`,
    method: 'get',
  });
}

function updateAccessControl(bucketName, data) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/acl`,
    method: 'put',
    data,
  });
}

function getBucketVersioning(bucketName) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/versioning`,
    method: 'get',
  });
}

function updateBucketVersioning(bucketName, data) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/versioning`,
    method: 'post',
    data,
  });
}

function getBucketPolicy(bucketName) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/policy`,
    method: 'get',
  });
}

function updateBucketPolicy(bucketName, data) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/policy`,
    method: 'put',
    data,
  });
}

function getLifeCycle(bucketName) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/lifecycle`,
    method: 'get',
  });
}

function updateLifeCycle(bucketName, data) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/lifecycle`,
    method: 'put',
    data,
  });
}

function deleteLifeCycle(bucketName) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/lifecycle`,
    method: 'delete',
  });
}

function getBucketCors(bucketName) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/cors`,
    method: 'get',
  });
}

function updateBucketCors(bucketName, data) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/cors`,
    method: 'put',
    data,
  });
}

function deleteBucketCors(bucketName) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/cors`,
    method: 'delete',
  });
}

function getBucketStatic(bucketName) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/static`,
    method: 'get',
  });
}

function updateBucketStatic(bucketName, data) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/static`,
    method: 'put',
    data,
  });
}

function deleteBucketStatic(bucketName) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/static`,
    method: 'delete',
  });
}

function getObjectAcl(bucketName, data) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/objects/acl`,
    method: 'post',
    data
  });
}

function updateObjectAcl(bucketName, data) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/objects/acl`,
    method: 'put',
    data,
  });
}

function getEndpoint() {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE2}/endpoints`,
    method: 'get',
  });
}

function getTemplate(params) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE2}/templates`,
    method: 'get',
    params,
  });
}
function checkExistsBucket(bucketName) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/exists`,
    method: 'get',
  });
}

function getPlan(bucketName) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/plan_type`,
    method: 'get',
  });
}

function getUsage(bucketName, params) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/usages`,
    method: 'get',
    params
  });
}

function getSubUser() {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/sub_users`,
    method: 'get',
  });
}
function createSubUser(data) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/sub_users`,
    method: 'post',
    data,
  });
}

function deleteSubUser(id) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/sub_users/${id}`,
    method: 'delete',
  });
}

function updateSubUser(id, data) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/sub_users/${id}`,
    method: 'patch',
    data,
  });
}

function createFolder(bucketName, folderPath) {
  return request({
    url: `${ENDPOINT.SIMPLE_STORAGE}/buckets/${bucketName}/folders/${folderPath}`,
    method: 'post',
  });
}

export default {
  getBucketList,
  createBucket,
  deleteBucket,
  getBucket,
  getS3UserInfo,
  createS3UserInfo,
  getBucketDetail,
  createKey,
  deleteKey,
  getFiles,
  getFilesNoPrefix,
  getFilesPrefix,
  deleteFile,
  uploadS3File,
  actionS3,
  downloadS3File,
  getAccessControl,
  updateAccessControl,
  getBucketVersioning,
  updateBucketVersioning,
  getBucketPolicy,
  updateBucketPolicy,
  getLifeCycle,
  updateLifeCycle,
  deleteLifeCycle,
  getBucketCors,
  updateBucketCors,
  deleteBucketCors,
  getBucketStatic,
  updateBucketStatic,
  deleteBucketStatic,
  getObjectAcl,
  updateObjectAcl,
  getEndpoint,
  getTemplate,
  checkExistsBucket,
  getPlan,
  getUsage,
  getSubUser,
  createSubUser,
  deleteSubUser,
  updateSubUser,
  deleteFileVersion,
  createFolder,
};